import React from "react";
import {
  Wrapper,
  Card,
  Title,
  Description,
  InfoBox,
  InfoTitle,
  InfoDescription,
} from "./SuccessRegistrationStep.elements";
import { useTranslation } from "react-i18next";
import { ReactComponent as SuccessIcon } from "../../assets/icons/generic_success.svg";
import { ReactComponent as GenericWarningIcon } from "../../assets/icons/generic_warning.svg";
import { ButtonGhost } from "../Button/Button";

export type SuccessRegistrationStepProps = {
  email: string;
  onBack: () => void;
};

export default function SuccessRegistrationStep({ email, onBack }: SuccessRegistrationStepProps) {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Card>
        <SuccessIcon />
        <Title>{t("registration.successStep.title")}</Title>
        <Description>
          {t("registration.successStep.description", { email })}
        </Description>
      </Card>
      <InfoBox>
        <GenericWarningIcon />
        <InfoTitle>{t("registration.successStep.infoTitle")}</InfoTitle>
        <InfoDescription>{t("registration.successStep.infoDescription")}</InfoDescription>
        <ButtonGhost onClick={onBack}>{t("registration.successStep.backButton")}</ButtonGhost>
      </InfoBox>
    </Wrapper>
  );
}
